// Reusable before/after transformation gallery
export default function BeforeAfterGallery({ items = [], compact = false }) {
  return (
    <div className={`grid ${compact ? "grid-cols-2 md:grid-cols-3" : "grid-cols-2 md:grid-cols-3 lg:grid-cols-4"} gap-3 md:gap-4`}>
      {items.map((t) => (
        <div
          key={t.slug}
          data-testid={`before-after-${t.slug}`}
          className="relative aspect-[3/4] rounded-xl overflow-hidden border border-[var(--leen-line)] group"
        >
          <img src={t.img} alt={`Transformation ${t.weight}`} className="img-zoom w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--leen-bg)] via-transparent to-transparent" />
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2">
            <span className="inline-flex items-center px-3 py-1.5 rounded-full bg-[var(--leen-pink)] text-white font-display text-[12px] tracking-wider whitespace-nowrap shadow-lg">
              {t.weight}
            </span>
          </div>
          {t.name && (
            <div className="absolute bottom-12 left-3 right-3 text-center">
              <p className="eyebrow text-white/90">{t.name}</p>
              {t.duration && <p className="text-[11px] text-white/60 mt-1">{t.duration}</p>}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export const TRANSFORMATIONS = [
  { slug: "t1", weight: "-41 LBS", name: "Sarah · 34", duration: "6 months", img: "https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=600&q=80" },
  { slug: "t2", weight: "-35 LBS", name: "Maya · 38", duration: "5 months", img: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=600&q=80" },
  { slug: "t3", weight: "-28 LBS", name: "Jess · 29", duration: "4 months", img: "https://images.unsplash.com/photo-1594381898411-846e7d193883?auto=format&fit=crop&w=600&q=80" },
  { slug: "t4", weight: "-52 LBS", name: "Marcus · 42", duration: "8 months", img: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&w=600&q=80" },
  { slug: "t5", weight: "-19 LBS", name: "Andre · 39", duration: "3 months", img: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=600&q=80" },
  { slug: "t6", weight: "-44 LBS", name: "Devon · 45", duration: "7 months", img: "https://images.unsplash.com/photo-1534438097545-a2c22c57f2ad?auto=format&fit=crop&w=600&q=80" },
  { slug: "t7", weight: "-31 LBS", name: "Tara · 41", duration: "5 months", img: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=600&q=80" },
  { slug: "t8", weight: "-26 LBS", name: "Lena · 32", duration: "4 months", img: "https://images.unsplash.com/photo-1518310952931-b1de897abd40?auto=format&fit=crop&w=600&q=80" },
];
